import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import backgroundImage from "../../images/location_new/case-img.jpg";
import { Link } from "gatsby";

function CaseSection(props) {
  return (
    <div
      className="common_section p-100"
      style={{ backgroundImage: `url(${backgroundImage})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={6} xl={5} xxl={6} className="my-auto">
            <div className="example" data-text="">
              <h2>
                Grab an Authentic Opportunity to Digitize Your Business in
                Houston
              </h2>
            </div>
            <p>
              TekRevol is a leading software development company in Houston,
              enabling businesses to transform by leveraging recent technologies
              and frameworks. We help our clients find the most lucrative growth
              opportunities and use our technical knowledge to capitalize on
              them entirely. We ceaselessly support our clients in achieving the
              highest levels of efficiency and profitability by employing
              growth-centric strategies backed by state-of-the-art software
              development practices.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
              rel="noopener"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default CaseSection;
